import { defineStore } from 'pinia'
import axios from 'axios'
import apiClient from '@/services/authService'

export const usePerfilStore = defineStore('perfil', {
  state: () => ({
    id: null,
    firstName: '',
    lastName: '',
    email: '',
    profileImage: '',
    carregado: false,
    notifications: false,
  }),

  actions: {
    async carregarPerfil() {
      try {
        const { data } = await apiClient.get('/api/v1/profile')

        // Garante que o ID seja um número
        this.id = data.id ? Number(data.id) : null
        this.firstName = data.nome || ''
        this.lastName = data.sobrenome || ''
        this.email = data.email || ''
        this.profileImage = data.imagem_base64
          ? (data.imagem_base64.startsWith('http')
              ? data.imagem_base64
              : `data:image/jpeg;base64,${data.imagem_base64}`)
          : ''
        this.notifications = data.notifications ?? false
        this.carregado = true


      } catch (error) {
        console.error("Erro ao carregar perfil:", error)
        this.limparPerfil()
      }
    },

    async salvarPerfil() {
      try {
        const payload = {
          id: this.id,
          nome: this.firstName,
          sobrenome: this.lastName,
          email: this.email,
          imagem_base64: this.profileImage.startsWith('data:image')
            ? this.profileImage.split(',')[1]
            : ''
        }

        await axios.put('/api/v1/profile', payload)
        await this.carregarPerfil()
        alert("Perfil atualizado com sucesso!")
      } catch (error) {
        console.error("Erro ao salvar perfil:", error)
        if (
          (error.response && error.response.status === 403) ||
          (error.message && error.message.includes("Incorrect padding"))
        ) {
          this.limparPerfil()
          await this.carregarPerfil()
        }
        alert("Erro ao salvar perfil.")
      }
    },

    atualizarImagem(imageBase64) {
      if (this.profileImage !== imageBase64) {
        this.profileImage = imageBase64
      }
    },

    limparPerfil() {
      this.id = null
      this.firstName = ''
      this.lastName = ''
      this.email = ''
      this.profileImage = ''
      this.carregado = false
      this.notifications = false
    },

    setNotificationsStatus(status) {
      this.notifications = status
    },
  },

  persist: {
    storage: sessionStorage,
    paths: ['id', 'firstName', 'lastName', 'email', 'profileImage', 'carregado', 'notifications']
  }
})
